import { FitText } from "./FitText";
import { COUNTRIES, statsFor, positionLabel } from "../../lib/shield";

const COND = "'Barlow Condensed', sans-serif";
const DISPLAY = "'Outfit', sans-serif";
const CODES = { "gb-eng": "ENG", "gb-sct": "SCO", "gb-wls": "WAL", "gb-nir": "NIR", ie: "IRE", gb: "GBR", us: "USA" };
export const countryCode = (code) => CODES[code] || (COUNTRIES.find(([c]) => c === code)?.[1] || "").slice(0, 3).toUpperCase();

const Img = ({ href, ...p }) => (href ? <image href={href} preserveAspectRatio="xMidYMid slice" {...p} /> : null);

// "Single row" card: rating & position top-left, country top-right, six stats in one row, flag/position/crest footer.
export const RowLayers = ({ design, flagHref, flagCode, hideCode, crestHref, filter, number }) => {
  const { player, stats, flag, crest, colours } = design;
  const c = colours.text;
  const pos = positionLabel(player) || "–";
  const showFlag = flag.show && flagHref;
  const showCrest = crest.show && crest.file && crestHref;
  return (
    <g data-layer="row-layout">
      <g fill={c} filter={filter}>
        <FitText testId="shield-rating" text={player.rating === "" ? "–" : player.rating} x={76} y={156} base={64} maxW={80} min={40}
          fontFamily={DISPLAY} fontWeight="900" opacity={player.rating === "" ? 0.6 : 1} />
        <FitText testId="shield-position" text={pos} x={76} y={190} base={28} maxW={80} min={14} fontFamily={COND} fontWeight="700" />
        {showFlag && !hideCode && <text x={324} y={128} textAnchor="middle" fontFamily={COND} fontWeight="700" fontSize="28" data-testid="shield-country-code">{flagCode || countryCode(flag.code)}</text>}
        <FitText text={pos} x={324} y={196} base={26} maxW={72} min={14} fontFamily={COND} fontWeight="700" />
      </g>
      {showFlag && <Img href={flagHref} x={300} y={138} width={48} height={30} data-layer="flag" />}
      <g filter={filter}>
        {player.clubName && <FitText testId="shield-club-name" text={player.clubName.toUpperCase()} x={200} y={414} base={15} maxW={240} min={9}
          fontFamily={COND} fontWeight="700" letterSpacing="2" fill={c} opacity=".85" />}
        <FitText testId="shield-name" {...number} text={(player.name || "Your name").toUpperCase()} x={200} y={460} base={52} maxW={318} min={22}
          fontFamily={COND} fontWeight="800" letterSpacing="1" fill={c} opacity={player.name ? 1 : 0.55} />
        {statsFor(design.sport).map((s, i) => {
          const x = 200 + (i - 2.5) * 50;
          const v = stats[s.key];
          return (
            <g key={s.key} data-testid={`shield-stat-${s.key}`} fill={c} textAnchor="middle">
              <text x={x} y={496} fontFamily={COND} fontWeight="600" fontSize="17" letterSpacing=".5">{s.key}</text>
              <text x={x} y={528} fontFamily={COND} fontWeight="800" fontSize="30" opacity={v === "" ? 0.6 : 1} data-testid={`shield-stat-${s.key}-value`}>{v === "" ? "–" : v}</text>
            </g>
          );
        })}
        <text x={200} y={572} textAnchor="middle" fontFamily={COND} fontWeight="700" fontSize="22" fill={c}>{pos}</text>
      </g>
      {showFlag && <Img href={flagHref} x={140} y={556} width={34} height={21} />}
      {showCrest && <image href={crestHref} x={228} y={550} width={30} height={32} preserveAspectRatio="xMidYMid meet" data-layer="crest" />}
    </g>
  );
};
